/* eslint-disable @typescript-eslint/no-explicit-any */
function getPageQueryParams() {
  const obj: any = {};
  const geturl = getPageUrl();
  if (!geturl.includes('?')) {
    return obj;
  }
  const getqyinfo = geturl.split('?')[1];
  const getqys = getqyinfo.split('&');
  for (let i = 0; i < getqys.length; i++) {
    const item = getqys[i].split('=');
    const key = item[0];
    const value = item[1];
    obj[key] = value;
  }
  return obj;
}

function getPageUrl() {
  return window.location.href;
}

export default {
  getPageQueryParams,
  getPageUrl,
};
